<template>
  <div class="section-main__warp">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template slot="search_targetYear">
        <div>
          <el-date-picker v-model="targetYear" type="year" value-format="yyyy" placeholder="请选择"></el-date-picker>
        </div>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
          新增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
      width="35%">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
        <el-form-item label="碳配额" prop="targetQuota">
          <el-input v-model="addForm.targetQuota" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="目标年份" prop="targetYear">
          <el-date-picker v-model="addForm.targetYear" value-format="yyyy" type="year" placeholder="请选择"
            style="width: 100%;" @change="targetYearChange"></el-date-picker>
        </el-form-item>
        <el-form-item label="基准年份" prop="standardYear">
          <el-date-picker v-model="addForm.standardYear" value-format="yyyy" type="year" placeholder="请选择"
            style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="相对基准年" prop="changeType">
          <el-select v-model="addForm.changeType" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in changeArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变化配额" prop="changeQuota">
          <el-input v-model="addForm.changeQuota" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="targetRemark">
          <el-input v-model="addForm.targetRemark" placeholder="请输入" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
        <el-button @click="addCancel('addForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/carbonTarget";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      targetYear: null,
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        targetQuota: [{ required: true, message: '请输入碳配额', trigger: ['blur', 'change'] }],
        targetYear: [{ required: true, message: '请选择目标年份', trigger: ['blur', 'change'] }],
        standardYear: [{ required: true, message: '请选择基准年份', trigger: ['blur', 'change'] }],
        changeType: [{ required: true, message: '请选择相对基准年', trigger: ['blur', 'change'] }],
        changeQuota: [{ required: true, message: '请输入变化配额', trigger: ['blur', 'change'] }]
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        targetId: null,
        targetQuota: '',
        targetYear: '',
        standardYear: '',
        changeType: '',
        changeQuota: '',
        targetRemark: ''
      },
      changeArr: [{ 'label': '增加', 'value': '1' }, { 'label': '减少', 'value': '0' }, { 'label': '相等', 'value': '2' }]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.targetYear = null
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        targetYear: this.targetYear
      };
      this.$fetch(api.carbonTarget.queryTargetList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    targetYearChange() {
      this.addForm.standardYear = (Number(this.addForm.targetYear) - 1) + ''
      this.$fetch(api.carbonTarget.queryTargetList, {
        pageNumber: 1,
        pageSize: 10,
        targetYear: this.addForm.standardYear
      }).then((response) => {
        if (response.success) {
          if (response.returnObj.length > 0) {
            const resultData = response.returnObj.list[0]
            let tempData = this.addForm.targetQuota - resultData.targetQuota
            if (tempData > 0) {
              this.addForm.changeType = '1'
            } else if (tempData < 0) {
              this.addForm.changeType = '0'
            } else if (tempData == 0) {
              this.addForm.changeType = '2'
            }
            this.addForm.changeQuota = Math.abs(tempData)
          }
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.addForm.targetId = null
      this.addForm.targetQuota = ''
      this.addForm.targetYear = ''
      this.addForm.standardYear = ''
      this.addForm.changeType = ''
      this.addForm.changeQuota = ''
      this.addForm.targetRemark = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.targetId) {
            let params = {
              targetId: this.addForm.targetId,
              targetQuota: this.addForm.targetQuota,
              targetYear: this.addForm.targetYear,
              standardYear: this.addForm.standardYear,
              changeType: this.addForm.changeType,
              changeQuota: this.addForm.changeQuota,
              targetRemark: this.addForm.targetRemark
            }
            this.$fetch(api.carbonTarget.updateTargetList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              targetQuota: this.addForm.targetQuota,
              targetYear: this.addForm.targetYear,
              standardYear: this.addForm.standardYear,
              changeType: this.addForm.changeType,
              changeQuota: this.addForm.changeQuota,
              targetRemark: this.addForm.targetRemark
            }
            this.$fetch(api.carbonTarget.addTargetList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改'
      this.addForm.targetId = row.targetId
      this.addForm.targetQuota = row.targetQuota
      this.addForm.targetYear = row.targetYear
      this.addForm.standardYear = row.standardYear
      this.addForm.changeType = row.changeType
      this.addForm.changeQuota = row.changeQuota
      this.addForm.targetRemark = row.targetRemark
      this.addVisible = true
    },
    // 删除
    handleDel(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/carbon/target/del/' + row.targetId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>
